import graphql from "../utils/graphql";

export default {
  async findDiasRendicion({ commit, getters, state }) {
    const { fspCodigo } = state.local;
    if (fspCodigo && !getters.getDiasRendicion.length) {
      try {
        const query = {
          query: ` query ($fspCodigo: Int!) {
            dias: obtenerDiasRendicion(fspCodigo: $fspCodigo) {
              diaRenCodigo
              etiqueta
            }
          }
          `,
          variables: {
            fspCodigo,
          }
        };
      const { dias } = await graphql.request(query);
      commit('setDiasRendicion', dias);
      } catch (err) {
        commit('error-notification', err.message);
      }
    }
  },
  async getTiposObservacionesActaLocal({ commit, getters }) {
    if (!getters.getTiposObservacionesLocal.length) {
      try {
        const query = {
          query: ` query {
            tiposObsLocal: tiposObservacionesLocal {
              codigo
              nombre
            }
          }
          `,
        };
      const { tiposObsLocal } = await graphql.request(query);
      commit('setTiposObservacionesLocal', tiposObsLocal);
      } catch (err) {
        commit('error-notification', err.message);
      }
    }
  },
  async loadTiposSituacionesEmergentesExaminador({ commit, getters }) {
    if (!getters.getTiposSitEmergentesExam.length) {
      try {
        const query = {
          query: ` query {
            situaciones: tiposSituacionesEmergentesExaminador {
              codigo
              nombre
            }
          }
          `,
        };
      const { situaciones} = await graphql.request(query);
      commit('setTiposSitEmergentesExam', situaciones);
      } catch (err) {
        commit('error-notification', err.message);
      }
    }
  },
  async loadPruebas({ state, commit, getters }) {
    if(getters.getPruebas.length) {
      return;
    }
    const { fspCodigo } = state.local;
    const query = {
      query: `query ($fspCodigo: Int!) {
        pruebas: pruebasPorFase (fspCodigo: $fspCodigo) {
          pruCodigo
          pruNombre
          obligatoria
          esCiencias
          nombreCorto
          orden
        }
      }
      `,
      variables: {
        fspCodigo
      }
    };
    try {
      const { pruebas } = await graphql.request(query);
      commit('setPruebas', { pruebas, fspCodigo });
    } catch (err) {
      commit('error-notification', err.message);
    }
  },
  async loadLocal({ commit, dispatch }, { local }) {
    commit('setLocal', local);
    dispatch('loadPruebas');
  }
};
